export const SCREENS = {
    SPLASH: 'splash',
    ONBOARDING: 'onboarding',
    HOME: 'home',
    QUESTIONNAIRE: 'questionnaire',
    SMART_QUESTIONNAIRE: 'smartQuestionnaire',
    CAMERA: 'camera',
    ANALYSIS: 'analysis',
    VERIFICATION: 'verification',
    RESULTS: 'results',
    BASELINE: 'baseline',
    CALIBRATION: 'calibration',
    HISTORY: 'history',
    SETTINGS: 'settings',
};

// Analysis types
export const ANALYSIS_TYPES = {
    FULL: 'full',
    TONGUE: 'tongue',
    FACE: 'face',
};

// Camera capture steps for each analysis type
export const CAMERA_STEPS = {
    [ANALYSIS_TYPES.FULL]: [
        { type: 'face', title: 'Chụp khuôn mặt', desc: 'Nhìn thẳng vào camera, giữ yên', frameType: 'circle' },
        { type: 'tongueTop', title: 'Mặt trên lưỡi', desc: 'Há miệng, thè lưỡi tự nhiên', frameType: 'oval' },
        { type: 'tongueBottom', title: 'Mặt dưới lưỡi', desc: 'Nâng lưỡi lên để thấy mạch máu', frameType: 'oval' },
    ],
    [ANALYSIS_TYPES.TONGUE]: [
        { type: 'tongueTop', title: 'Mặt trên lưỡi', desc: 'Há miệng, thè lưỡi tự nhiên', frameType: 'oval' },
        { type: 'tongueBottom', title: 'Mặt dưới lưỡi', desc: 'Nâng lưỡi lên để thấy mạch máu', frameType: 'oval' },
    ],
    [ANALYSIS_TYPES.FACE]: [
        { type: 'face', title: 'Chụp khuôn mặt', desc: 'Nhìn thẳng vào camera, giữ yên', frameType: 'circle' },
    ],
};
